import { useRouter } from 'next/router'
import { dictionary } from './translations'

const locales = [
  'da', // Danish,
  'de', // German
  'el', // Greek
  'es-419', // Spanish (Latin America)
  'es', // Spanish
  'fi', // Finnish
  'fr-CA', // French (Canadian)
  'fr', // French
  'it', // Italian
  'nl', // Dutch,
  'nl-be', // Dutch (Belgium)
  'pt-BR', // Brazilian (Portuguese)
  'pt', // Portuguese
  'sv', // Swedish
  'en-GB', // English (UK)
  'en', // English (US)
  'en-XA', // English (Pseudo Locale)
];

const spanishLatinAmericanCountries = [
  'es-AR', // Argentina
  'es-BO', // Bolivia
  'es-CL', // Chile
  'es-CO', // Colombia
  'es-CR', // Costa Rica
  'es-CU', // Cuba
  'es-DO', // Dominican Republic
  'es-EC', // Ecuador
  'es-SV', // El Salvador
  'es-GT', // Guatemala
  'es-HN', // Honduras
  'es-MX', // Mexico
  'es-NI', // Nicaragua
  'es-PA', // Panama
  'es-PY', // Paraguay
  'es-PE', // Peru
  'es-PR', // Puerto Rico
  'es-UY', // Uruguay
  'es-VE', // Venezuela
];

const defaultLocale = 'en';

export const useTranslation = () => {
  const router = useRouter();

  let forcedLang
  try {
    forcedLang = router.query.lang;
  } catch (e) {}

  let browserLang;
  let locale = defaultLocale;
  if (typeof navigator !== "undefined") {
    browserLang = forcedLang || navigator.language || navigator['userLanguage'];

    // try to match exact language
    if (locales.includes(browserLang)) {
      locale = browserLang;
    } else if (spanishLatinAmericanCountries.includes(browserLang)) { // Serve Spanish (Latin American)
      locale = 'es-419';
    } else if (locales.includes(browserLang.split('-')?.[0])) { // try to match root language
      locale = browserLang.split('-')[0];
    }
  }

  return {
    translate: (term) => {
      const translation = dictionary[locale][term] || dictionary[defaultLocale][term]

      return Boolean(translation) ? translation : term
    },
    locale,
  }
}
